import { LoginStateEnum } from '@/enums/loginEnum'
import { PageEnum } from '../enums/pageEnum'

// 是否有登录状态
export const loginStateMatchList = [
  { state: LoginStateEnum.LOGIN, target: PageEnum.BASE_LOGIN },
  { state: LoginStateEnum.NO_LOGIN_BUT_HAVE_TOKEN, target: PageEnum.BASE_HOME },
  { state: LoginStateEnum.NO_LOGIN_AND_TOKEN, target: PageEnum.BASE_HOME }
]


export const loginState = LoginStateEnum.NO_LOGIN_AND_TOKEN
